export default __webpack_public_path__ + "static/product_item_004-514cedf37e545db603ed5cb7f78185ef.jpg";